import React, { useEffect, useState } from 'react';

import { ProgramTaskStatus } from '@vestahealthcare/common/enums';
import { translate } from '@vestahealthcare/common/i18n';

import { Modal, Select } from 'styleguide-v2';

interface Props {
  'data-cy'?: string;
  open?: boolean;

  onSubmit: (status: ProgramTaskStatus) => void;
}

export const PodTaskCompleteChildModal = ({ open, onSubmit }: Props) => {
  const [status, setStatus] = useState<ProgramTaskStatus>();

  const reset = () => {
    setStatus(undefined);
  };

  useEffect(() => {
    if (open) reset();
  }, [open]);

  return (
    <Modal
      onSubmit={async () => status && onSubmit(status)}
      open={!!open}
      submitDisabled={!status}
      title={translate('global.warning')}
    >
      <p>{translate('pods.metrics.completeChildModal.body')}</p>
      <Select
        data-cy="pod-task-close-child-status"
        getItemLabel={(status: ProgramTaskStatus) => status.toString()}
        items={[ProgramTaskStatus.COMPLETED, ProgramTaskStatus.INCOMPLETE]}
        label={translate('pods.metrics.completeChildModal.status')}
        onChange={setStatus}
        required
        value={status}
      />
    </Modal>
  );
};
